var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * 
 * @file Metadata sidebar component
 * @author Box
 */

import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Instances from 'box-react-ui/lib/features/metadata-instance-editor/Instances';
import EmptyContent from 'box-react-ui/lib/features/metadata-instance-editor/EmptyContent';
import TemplateDropdown from 'box-react-ui/lib/features/metadata-instance-editor/TemplateDropdown';
import LoadingIndicator from 'box-react-ui/lib/components/loading-indicator/LoadingIndicator';
import LoadingIndicatorWrapper from 'box-react-ui/lib/components/loading-indicator/LoadingIndicatorWrapper';
import InlineError from 'box-react-ui/lib/components/inline-error/InlineError';
import messages from '../messages';
import SidebarContent from './SidebarContent';
import APIContext from '../APIContext';
import API from '../../api';

var MetadataSidebar = function (_React$PureComponent) {
    _inherits(MetadataSidebar, _React$PureComponent);

    function MetadataSidebar() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, MetadataSidebar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MetadataSidebar.__proto__ || Object.getPrototypeOf(MetadataSidebar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isLoading: false,
            hasError: false
        }, _this.errorCallback = function () {
            _this.setState({ isLoading: false, hasError: true });
        }, _this.getMetadataEditors = function () {
            var _this$props = _this.props,
                api = _this$props.api,
                file = _this$props.file,
                getMetadata = _this$props.getMetadata;

            api.getMetadataAPI(true).getEditors(file, function (_ref2) {
                var editors = _ref2.editors,
                    templates = _ref2.templates;

                _this.setState({
                    templates: templates,
                    editors: editors.slice(0),
                    isLoading: false,
                    hasError: false
                });
            }, _this.errorCallback, getMetadata);
        }, _this.onRemove = function (id) {
            var _this$props2 = _this.props,
                api = _this$props2.api,
                file = _this$props2.file;

            var editor = _this.getEditor(id);
            if (!editor) {
                return;
            }

            api.getMetadataAPI(false).deleteMetadata(file, editor.template, function () {
                return _this.onRemoveSuccessHandler(editor);
            }, _this.errorCallback);
        }, _this.onAddSuccessHandler = function (editor) {
            var _this$state$editors = _this.state.editors,
                editors = _this$state$editors === undefined ? [] : _this$state$editors;

            var clone = editors.slice(0);
            clone.push(editor);
            _this.setState({ editors: clone, isLoading: false });
        }, _this.onAdd = function (template) {
            var _this$props3 = _this.props,
                api = _this$props3.api,
                file = _this$props3.file;

            _this.setState({ isLoading: true });
            api.getMetadataAPI(false).createMetadata(file, template, _this.onAddSuccessHandler, _this.errorCallback);
        }, _this.onSave = function (id, ops) {
            var _this$props4 = _this.props,
                api = _this$props4.api,
                file = _this$props4.file;

            var oldEditor = _this.getEditor(id);
            if (!oldEditor) {
                return;
            }

            api.getMetadataAPI(false).updateMetadata(file, oldEditor.template, ops, function (newEditor) {
                _this.onSaveSuccessHandler(oldEditor, newEditor);
            }, _this.errorCallback);
        }, _this.onModification = function (id, isDirty) {
            var _this$state$editors2 = _this.state.editors,
                editors = _this$state$editors2 === undefined ? [] : _this$state$editors2;

            var index = editors.findIndex(function (_ref3) {
                var instance = _ref3.instance;
                return instance.id === id;
            });
            if (index === -1) {
                return;
            }

            var editor = _extends({}, editors[index]);
            editor.isDirty = isDirty;
            var clone = editors.slice(0);
            clone.splice(index, 1, editor);
            _this.setState({ editors: clone });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(MetadataSidebar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.getMetadataEditors();
        }

        /**
         * Sets the error state to true
         *
         * @return {void}
         */


        /**
         * Fetches the metadata editors
         *
         * @return {void}
         */

    }, {
        key: 'canEdit',


        /**
         * Checks upload permission
         *
         * @return {boolean} - true if metadata can be edited
         */
        value: function canEdit() {
            var file = this.props.file;
            var _file$permissions = file.permissions,
                permissions = _file$permissions === undefined ? {} : _file$permissions;
            var can_upload = permissions.can_upload;

            return !!can_upload;
        }

        /**
         * Editor we are changing
         *
         * @param {number} id - instance id
         * @return {Object} editor instance
         */

    }, {
        key: 'getEditor',
        value: function getEditor(id) {
            var _state$editors = this.state.editors,
                editors = _state$editors === undefined ? [] : _state$editors;

            return editors.find(function (_ref4) {
                var instance = _ref4.instance;
                return instance.id === id;
            });
        }

        /**
         * Instance remove success handler
         *
         * @param {Object} editor - the editor to remove
         * @return {void}
         */

    }, {
        key: 'onRemoveSuccessHandler',
        value: function onRemoveSuccessHandler(editor) {
            var _state$editors2 = this.state.editors,
                editors = _state$editors2 === undefined ? [] : _state$editors2;

            var clone = editors.slice(0);
            clone.splice(editors.indexOf(editor), 1);
            this.setState({ editors: clone });
        }

        /**
         * Instance remove handler
         *
         * @param {number} id - instance id
         * @return {void}
         */


        /**
         * Instance add success handler
         *
         * @param {number} id - instance id
         * @return {void}
         */


        /**
         * Instance add handler
         *
         * @param {Object} template - instance template
         * @return {void}
         */

    }, {
        key: 'onSaveSuccessHandler',


        /**
         * Instance save success handler
         *
         * @param {Object} oldEditor - prior editor
         * @param {Object} newEditor - updated editor
         * @return {void}
         */
        value: function onSaveSuccessHandler(oldEditor, newEditor) {
            var _state$editors3 = this.state.editors,
                editors = _state$editors3 === undefined ? [] : _state$editors3;

            var clone = editors.slice(0);
            clone.splice(editors.indexOf(oldEditor), 1, newEditor);
            this.setState({ editors: clone });
        }

        /**
         * Instance save handler
         *
         * @param {number} id - instance id
         * @param {Array} ops - json patch ops
         * @return {void}
         */


        /**
         * Instance dirty handler
         *
         * @param {number} id - instance id
         * @param {boolean} isDirty - instance dirty state
         * @return {void}
         */

    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                editors = _state.editors,
                templates = _state.templates,
                isLoading = _state.isLoading,
                hasError = _state.hasError;

            var showEditor = !!templates && !!editors;
            var showLoadingIndicator = !hasError && !showEditor;
            var canEdit = this.canEdit();
            var showTemplateDropdown = showEditor && canEdit;
            var showEmptyContent = showEditor && editors.length === 0;

            return React.createElement(
                SidebarContent,
                {
                    title: React.createElement(FormattedMessage, messages.sidebarMetadataTitle),
                    actions: showTemplateDropdown ? React.createElement(TemplateDropdown, {
                        hasTemplates: templates && templates.length !== 0,
                        isDropdownBusy: false,
                        onAdd: this.onAdd,
                        templates: templates,
                        usedTemplates: editors && editors.map(function (editor) {
                            return editor.template;
                        })
                    }) : null
                },
                hasError && React.createElement(
                    InlineError,
                    {
                        title: React.createElement(FormattedMessage, messages.sidebarMetadataErrorTitle)
                    },
                    React.createElement(FormattedMessage, messages.sidebarMetadataErrorContent)
                ),
                showLoadingIndicator && React.createElement(LoadingIndicator, null),
                showEditor && React.createElement(
                    LoadingIndicatorWrapper,
                    {
                        className: 'metadata-instance-editor',
                        isLoading: isLoading
                    },
                    showEmptyContent ? React.createElement(EmptyContent, { canAdd: canEdit }) : React.createElement(Instances, {
                        editors: editors,
                        onModification: this.onModification,
                        onSave: this.onSave,
                        onRemove: this.onRemove
                    })
                )
            );
        }
    }]);

    return MetadataSidebar;
}(React.PureComponent);

export { MetadataSidebar as MetadataSidebarComponent };
export default (function (props) {
    return React.createElement(
        APIContext.Consumer,
        null,
        function (api) {
            return React.createElement(MetadataSidebar, _extends({}, props, { api: api }));
        }
    );
});